import { SidebarMenuButton } from "@/components/ui/sidebar";
import { useSidebar } from "@/components/ui/sidebar.utils";
import { Menu } from "lucide-react";
import { Image } from "@unpic/react";
import TrudLogo from "@/assets/images/logos/isologo.webp";

function CustomSidebarTrigger() {
  const { open, setOpen, openMobile, setOpenMobile, isMobile } = useSidebar();

  return (
    <SidebarMenuButton className="cursor-default flex items-center gap-4 justify-between hover:bg-transparent active:bg-transparent">
      {open && (
        <span>
          <Image
            src={TrudLogo}
            alt="Trud"
            width={120}
            height={40}
            priority
            className={"cursor-pointer"}
          />
        </span>
      )}

      <Menu
        onClick={() => {
          if (isMobile) {
            setOpenMobile(!openMobile);
          } else {
            setOpen(!open);
          }
        }}
        className="text-text-primary cursor-pointer flex text-2xl hover:bg-sidebar-accent hover:text-sidebar-accent-foreground"
      />
    </SidebarMenuButton>
  );
}

export default CustomSidebarTrigger;
